import {QRCodeCanvas} from 'qrcode.react'
import DefaultModal from 'shared/ui/DefaultModal'
import DefaultSpinLoading from 'shared/ui/DefaultspinLoading'
import Style from '../../style'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useCountdownRefetch from 'shared/hooks/useCountdownRefetch'
import {QR_REFRESH_TIME} from 'shared/constant/countdown'
import useGetAccountParticipationTicketQRGenerate from 'entity/account/useGetAccountParticipationTicketQRGenerate'
import ticketStatusChecker from 'shared/lib/ticketStatusChecker'

const TicketDetailModal = ({
	isTicketOpen,
	setIsTicketOpen,
	fetchParticipationTicketList,
}) => {
	const [ticketDetail, loading, refetch] =
		useGetAccountParticipationTicketQRGenerate(isTicketOpen?.serial_number)
	const ticketStatus = ticketStatusChecker(isTicketOpen)

	// Only run countdown when modal is open and there's a valid QR code to refresh
	const shouldRunCountdown =
		isTicketOpen &&
		!loading &&
		!ticketDetail?.data?.error_code &&
		ticketDetail?.data?.qr_token

	// Use countdown refetch hook
	const {countdown, handleRefetch} = useCountdownRefetch(refetch, {
		initialTime: QR_REFRESH_TIME,
		shouldRun: shouldRunCountdown,
		resetTrigger: isTicketOpen,
	})

	if (loading)
		return (
			<DefaultModal title='Ticket' closeEvent={() => setIsTicketOpen(null)}>
				<Style.ModalDiv>
					<h2>{isTicketOpen?.event_name}</h2>
					<DefaultSpinLoading size='200px' color='#3498db' />
				</Style.ModalDiv>
			</DefaultModal>
		)

	return (
		<DefaultModal
			title='Ticket'
			closeEvent={() => {
				setIsTicketOpen(null)
				fetchParticipationTicketList()
			}}
		>
			<Style.ModalDiv>
				<h2>{isTicketOpen?.event_name}</h2>
				<Style.ModalArea>
					<p>{isTicketOpen?.address}</p>
					<p>{timestampCalculator(isTicketOpen?.event_date)}</p>
				</Style.ModalArea>
				{!ticketDetail?.data?.error_code && ticketDetail?.data?.qr_token ? (
					<Style.ModalArea>
						<p>Ticket QR Code</p>
						<QRCodeCanvas size={250} value={ticketDetail?.data?.qr_token} />
						<Style.QRControls>
							{shouldRunCountdown && (
								<p className='countdown-text'>Refresh in {countdown}s</p>
							)}
							<Style.RefreshButton onClick={handleRefetch}>
								Refresh now
							</Style.RefreshButton>
						</Style.QRControls>
					</Style.ModalArea>
				) : (
					<Style.ModalArea>
						<p>Ticket Status</p>
						<h3 style={{color: ticketStatus.isValid ? '#28a745' : '#dc3545'}}>
							{ticketStatus.reason}
						</h3>
					</Style.ModalArea>
				)}

				<Style.ModalArea>
					<p>Ticket Serial Number</p>
					<h1>{isTicketOpen?.serial_number}</h1>
				</Style.ModalArea>
			</Style.ModalDiv>
		</DefaultModal>
	)
}

export default TicketDetailModal
